<template>
<div class="counting-container">
    <Row type="flex">
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">实时位移</div>
            <Row type="flex">
                <Col flex="1">
                <div>定位销</div>
                </Col>
                <Col flex="1">
                <div>动电极</div>               
                </Col>
            </Row>

        </Card>
        </Col>
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">静电极位置偏移量录入</div>

            <Row type="flex">
                <Col flex="1">
                初始位置
                </Col>
                <Col flex="1">

                </Col>
              
            </Row>
             <Row type="flex">
                <Col flex="1">
                偏移量
                </Col>
                <Col flex="1">

                </Col>
              
            </Row>
             
            <Row type="flex">
                <Col flex="1">
                <Button type="primary" @click="normalControl('CmdMan2',14)" >①初始位置录入</Button>
                </Col>
                <Col flex="1">
                <Button type="primary" @click="normalControl('CmdMan2',15)" >②偏移量录入</Button>
                </Col>
                
            </Row>

        </Card>

        </Col>
    </Row>

</div>
</template>

<script>
import axios from 'axios';
import {
    API_URL
} from '@/constants/const'
import {
    mapGetters
} from 'vuex'
import {
    postJsError
} from '@/util/util.js'
export default {
    name: 'CountPanel',
    props: {
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            systemData: {},
            originalData: {},
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),        
    },
    async created() {
        this.init();
    },
    methods: {
        async init() {
            const url = API_URL['501SystemGet'];
            let params = {
                mac: this.mac
            }
            let res = await axios.get(url, {
                    params: params
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
                if (res.data.data.param) {
                    for (var i in res.data.data.param) {
                        this.$set(this.systemData, i, res.data.data.param[i])
                    }
                    // 保存原始值快照
                    this.originalData = JSON.parse(JSON.stringify(this.systemData))
                }
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async download(changed){
          const url = API_URL['501CommuDownload'];
            // 计算与原始值的差异，只发送变更的字段（nil 指针 = 不写入）
            
            
            let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(changed));
            let res = await axios.post(url, formData)
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
              // 写入成功，更新原始快照
              this.$Message.success(res.data.msg);
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },   
        async normalControl(key,offset){
            const val = 1 << offset
            let changed = {}
            changed[key] = val
            await this.download(changed)
        }
    }
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.counting-container {
    padding: 10px;
}
</style>
